
const Footer = () => {
    return (
    <footer className="flex-shrink-0 py-2 bg-dark text-white-50 fixed-bottom">
    <div className="container text-center">
      <small cl>2023&copy; Cap Corner® -  Underground Streetwear Brand</small>
    </div>
  </footer>
  )
    
  
}
export default Footer;

